<div class="container favorites-tab-container">
    <div class="row">
        <div class="col-12 text-center">
            <p class="favorites-tab-sub-header">{{consts.LABEL_EDIT_FAVORITES}}</p>
        </div>
        <div class="favorites-edit">
            <div class="col-12 mb-4">
                <div class="favorites-tab-location-search">
                    <form>
                        <mat-form-field
                            appearance="none"
                            floatLabel="never"
                            class="favorites-tab-form-field"
                        >
                            <input
                                type="text"
                                placeholder={{consts.PLACEHOLDER_SEARCH}}
                                matInput
                                [formControl]="location"
                                [matAutocomplete]="auto"
                                (input)="searchCountry($event.target.value)"
                                #clearInputField
                                [appClearInput]= "clearInputField.value"
                            >
                            <mat-icon
                                matSuffix
                                svgIcon="hub_search"
                                class="dxc-purple favorites-tab-location-search-icon"
                            >
                            </mat-icon>
                            <mat-autocomplete
                                #auto="matAutocomplete"
                                (optionSelected)="setRecentSearch($event.option.value)"
                            >
                                <ng-container *ngIf="!zeroQueryList">
                                    <cdk-virtual-scroll-viewport
                                        [itemSize]="optionsListLength"
                                        [style.height.px]="optionsListItemHeight * (locations.length < optionsListLength ? locations.length : optionsListLength)"
                                    >
                                        <mat-option
                                            *cdkVirtualFor="let location of locations"
                                            [value]="location"
                                        >
                                            {{location.city + ', ' + location.country +', ' + (location.province ? location.province : '')}}
                                        </mat-option>
                                    </cdk-virtual-scroll-viewport>
                                </ng-container>
                                <ng-container *ngIf="zeroQueryList">
                                    <cdk-virtual-scroll-viewport
                                        [itemSize]="optionsListLength"
                                        [style.height.px]="
                                        optionsListItemHeight * (zeroQueryList.length < optionsListLength ? zeroQueryList.length : optionsListLength)"
                                    >
                                        <mat-option
                                            *ngFor="let recent of zeroQueryList"
                                            [value]="recent"
                                        >
                                            <mat-icon
                                                class="fave-option-icon"
                                                svgIcon="hub_clock"
                                            >
                                            </mat-icon>
                                            {{recent.city + ', ' + recent.country + ', ' +(recent.province ? recent.province : '')}}
                                        </mat-option>
                                    </cdk-virtual-scroll-viewport>
                                </ng-container>
                            </mat-autocomplete>
                        </mat-form-field>
                    </form>
                    <p
                        class="favorites-tab-edit-error-text"
                        *ngIf="errorMessage$ | async as errorMessage"
                    >
                        {{errorMessage}}
                    </p>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div
                    class="favorites-tab-favorites-list"
                    cdkDropList
                    (cdkDropListDropped)="drop($event)"
                >
                    <div
                        class="favorites-tab-favorite-box"
                        *ngIf="settings.favorites.length <= 0"
                    >
                        {{consts.LABEL_NO_FAVORITES}}
                    </div>
                    <div
                        class="favorites-tab-favorite-box"
                        *ngFor="let favorite of settings.favorites; index as i"
                        cdkDrag
                    >
                        <div class="col-9 favorites-tab-favorite-box-text">
                            {{favorite.city + ', ' + favorite.country + ', '+(favorite.province ? favorite.province : '')}}
                        </div>
                        <div class="col-3 favorites-tab-favorite-box-buttons">
                            <mat-icon
                                cdkDragHandle
                                class="favorites-tab-favorite-drag-icon"
                                svgIcon="hub_drag"
                            >
                            </mat-icon>
                            <mat-icon
                                svgIcon="hub_trash"
                                class="favorites-tab-favorite-trash-icon"
                                (click)="removeFavorite(i)"
                            >
                            </mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
